import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// Old SchoolHeader deleted - use DashboardLayout instead
import DashboardLayout from "../common/DashboardLayout";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import AuthServices from "../../services/AuthServices";
import "../../assets/css/certificate.css";
import {
  certiborder,
  certificateImg,
  backgroundcertificateImg,
} from "../imagepath";
import { format } from "date-fns";
import { useParams } from "react-router-dom";
const ViewCertificate = () => {
  const navigate = useNavigate();
  const certificateRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const { userid, type } = useParams();
  // var user = JSON.parse(localStorage.getItem("user"));
  const [certificatesData, setCertificatesData] = useState();
  const [title, setCertificateTitle] = useState();

  const handleGenerateImage = async () => {
    try {
      if (certificateRef.current) {
        const canvas = await html2canvas(certificateRef.current);
        setImageSrc(canvas.toDataURL("image/png"));
      }
    } catch (error) {
      console.error("Error generating image:", error);
    }
  };

  useEffect(() => {
    // Fetch certificate titles from the API
    const viewCertificates = async () => {
      try {
        const response = await AuthServices.viewCertificateByUserId({
          userid: userid,
          type: atob(type),
        });

        console.log(response, "get data");
        setCertificateTitle(response.type);
        setCertificatesData(response.certificatedata);
      } catch (error) {
        console.error("Error fetching certificates:", error);
      }
    };

    viewCertificates();
    handleGenerateImage();
  }, []);

  console.log(certificatesData, "get data");
  // const handleDownloadImage = async () => {

  //   if (certificateRef.current) {
  //     const canvas = await html2canvas(certificateRef.current, {
  //       scale: 2, // Improves resolution
  //       useCORS: true, // Allows external images to be captured
  //     });

  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("landscape", "mm", "a4"); // Landscape mode
  //     const imgWidth = 260; // Adjust based on PDF width
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //     pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
  //     pdf.save(title + ".pdf");
  //   }
  // };

  const handleDownloadImage = async () => {
    if (certificateRef.current) {
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2, // Higher resolution
        useCORS: true, // Allow cross-origin images
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("landscape", "mm", "a4"); // Landscape mode

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Calculate new image dimensions to maintain aspect ratio
      const imgWidth = pdfWidth - 20; // Adjust for padding
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (imgHeight > pdfHeight) {
        // If the image is too tall, fit it within the PDF height
        const scaleFactor = pdfHeight / imgHeight;
        pdf.addImage(imgData, "PNG", 10, 10, pdfWidth - 20, pdfHeight - 20);
      } else {
        pdf.addImage(imgData, "PNG", 10, 10, pdfWidth, imgHeight);
      }

      pdf.save(`${title || "Certificate"}.pdf`);
      navigate("/certificates");
    }
  };

  return (
    <>
      <DashboardLayout
        role={1}
        layoutType="topnav"
        activeMenu="Certificate"
        showBreadcrumbs={true}
      >
        <div className="main-wrapper">
          {/* Old SchoolHeader removed */}
          <div className="breadcrumb-bar breadcrumb-bar-info">
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-12">
                  <div className="breadcrumb-list">
                    <h2 className="breadcrumb-title">Certificate</h2>
                    {/* <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={process.env.REACT_APP_URL || "/"}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Dashboard
                      </li>
                    </ol>
                  </nav> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="page-content">
            <div className="container">
              <div className="view-certficate-main">
                <div className="d-flex justify-content-end gap-3">
                  <Link to={`/schooledit/${userid}`}>
                    <button
                      style={{
                        marginBottom: "60px",
                        position: "relative",
                        marginTop: "20px",
                        padding: "10px 20px",
                        fontSize: "16px",
                      }}
                    >
                      <i className="fa fa-edit m-1" aria-hidden="true" />
                      Edit
                    </button>
                  </Link>
                  <button
                    className="certi-button"
                    onClick={handleDownloadImage}
                    style={{
                      marginTop: "20px",
                      padding: "10px 20px",
                      fontSize: "16px",
                    }}
                  >
                    <i className="fa fa-download" aria-hidden="true"></i> Download
                    Pdf
                  </button>
                </div>

                {certificatesData ? (
                  <div
                    className="certi-div"
                    ref={certificateRef}
                    style={{
                      position: "relative",
                      background: "none",
                      padding: "0",
                    }}
                  >
                    <img
                      src={certiborder}
                      alt="Border Frame"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        zIndex: 0,
                      }}
                    />
                    <div
                      style={{
                        position: "relative",
                        zIndex: 1,
                        width: "90%",
                        height: "1120px", // Fill all space so PDF includes it
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        color: "#000000",
                        textAlign: "center",
                        padding: "20px",
                        boxSizing: "border-box",
                        margin: "0 auto",
                      }}
                    >
                      <img src={backgroundcertificateImg} className="certi-backimg" />
                      <h1 className="certi-heading">
                        National Certification Program
                      </h1>
                      <p className="certi-sub-heading">{certificatesData.name}</p>

                      <p style={{ fontSize: "32px" }}>
                        {certificatesData.address}
                      </p>
                      <p
                        style={{
                          fontSize: "24px",
                          marginTop: "5px",
                          fontWeight: "700",
                        }}
                      >
                        Is Awarded & Certified on
                      </p>

                      <p className="certi-date">
                        {" "}
                        {format(
                          new Date(certificatesData.completionDate),
                          "MMMM do yyyy"
                        )}
                      </p>
                      <p style={{ fontSize: "24px", fontWeight: "600" }}>
                        By the
                      </p>
                      <p
                        style={{
                          fontSize: "27px",
                          fontWeight: "800",
                          marginTop: "30px",
                        }}
                      >
                        <span className="certi-pink">Angel</span>
                        <span className="certi-blue">Watch</span> Foundation
                      </p>
                      <p style={{ fontSize: "21px", fontWeight: "500" }}>
                        Expiration &nbsp;
                        {format(
                          new Date(certificatesData.expirationDate),
                          "MMMM do yyyy"
                        )}
                      </p>

                      <p className="align-img">
                        <img src={certificateImg} className="certi-left-img" />
                        <img src={certificateImg} className="certi-right-img" />
                      </p>
                      <p style={{ marginTop: "30px" }}>
                        <h2
                          style={{
                            fontSize: "16px",
                            marginBottom: "2px",
                            fontWeight: "500",
                          }}
                        >
                          Lic.{certificatesData.stateid}
                        </h2>
                        <h2
                          style={{
                            fontSize: "30px",
                            marginTop: "40px",
                            color: "red",
                            fontWeight: "700",
                            fontFamily: "Tahoma",
                          }}
                        >
                          {title}
                        </h2>
                      </p>

                      {/* <p></p> */}
                      <p
                        style={{
                          fontSize: "24px",
                          marginTop: "20px",
                          fontWeight: "600",
                        }}
                      >
                        The <span className="certi-pink">Angel</span>
                        <span className="certi-blue">Watch</span> National
                        Accreditation Program for the Safety & Security of
                        Children
                      </p>
                      <p className="left-text">www.AngelWatch.org</p>
                      <p className="right-text">Phone: 1-800-381-6794</p>

                      {/* Watermark Overlay */}
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%) rotate(45deg)",
                          fontSize: "80px",
                          fontWeight: "bold",
                          color: "rgba(180, 180, 180, 0.5)",
                          opacity: 0.5,
                          pointerEvents: "none",
                          userSelect: "none",
                          zIndex: 999,
                          whiteSpace: "nowrap",
                        }}
                      >
                        Expires {format(new Date(certificatesData.expirationDate), "MM/dd/yyyy")}
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          {/* Display the Generated Image */}
          {/* {imageSrc && (
                <div style={{ marginTop: '20px' }}>
                    <h2>Generated Certificate:</h2>
                    <img 
                        src={imageSrc} 
                        alt="Generated Certificate" 
                        style={{ 
                            border: '1px solid #ccc', 
                            marginTop: '10px',
                            maxWidth: '100%' // Ensure the image fits within the container
                        }} 
                    />
                </div>
            )} */}
        </div>
      </DashboardLayout>
    </>
  );
};

export default ViewCertificate;
